<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Modal, Text } from '@Shelly/shelly-design-system';
	import type { EnergyTariff } from 'src/types/EnergyTariff';

	import DOMPurify from 'dompurify';

	export let showModal: boolean = false;
	export let tariff: EnergyTariff;

	const handleClose = () => {
		showModal = false;
	};

	let savings = tariff.savings;
	let header = DOMPurify.sanitize(savings?.content?.tooltip?.header || '');
	let body = DOMPurify.sanitize(savings?.content?.tooltip?.body || '');
</script>

<Modal
	{showModal}
	on:close={handleClose}
	backdropClose={true}
	title={header ||
		$format('energy_price_savings_info', {
			default: 'Wie wird die Ersparnis berechnet?',
			locale: 'de',
		})}
>
	<svelte:fragment slot="content">
		{#if body}
			<div class="savings-content">
				<Text styleType="body-small" class="savings-body">
					{@html body}
				</Text>
			</div>
		{/if}
	</svelte:fragment>
</Modal>

<style>
	.savings-content {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-s);
	}
</style>
